import { FC } from 'react';

/**
 * THE BRAND MARK ONLY — not the vendor button.
 *
 * `google.svg` and `microsoft.svg` in the asset bucket are whole 100x48
 * BUTTONS: each carries its own rounded plate (white for Google, #4F5659 for
 * Microsoft) with a small glyph in the middle. Rendered as an icon inside our
 * own tile they could never match the theme — or each other — and scaling the
 * button down to icon size shrank the glyph to a speck, which is exactly how
 * they were reported.
 *
 * These are the same paths from those files with the background rect dropped
 * and the viewBox cropped to the glyph, so the mark fills the space it is given
 * and sits on whatever ground the tile has. No new artwork, and nothing to
 * fetch — which also removes the skeleton-loader dance the log-in page needed
 * while the image loaded.
 */
export const SocialMark: FC<{ brand: 'google' | 'microsoft'; size?: number }> = ({
	brand,
	size = 22,
}) =>
	brand === 'google' ? (
		<svg
			width={size}
			height={size}
			viewBox="39 11.5 25.4 27"
			fill="none"
			aria-hidden="true"
			focusable="false"
		>
			<path d="M64.0738 22.3885H62.9998V22.3332H50.9998V27.6665H58.5352C57.4358 30.7712 54.4818 32.9998 50.9998 32.9998C46.5818 32.9998 42.9998 29.4178 42.9998 24.9998C42.9998 20.5818 46.5818 16.9998 50.9998 16.9998C53.0392 16.9998 54.8945 17.7692 56.3072 19.0258L60.0785 15.2545C57.6972 13.0352 54.5118 11.6665 50.9998 11.6665C43.6365 11.6665 37.6665 17.6365 37.6665 24.9998C37.6665 32.3632 43.6365 38.3332 50.9998 38.3332C58.3632 38.3332 64.3332 32.3632 64.3332 24.9998C64.3332 24.1058 64.2412 23.2332 64.0738 22.3885Z" fill="#FFC107" />
			<path d="M39.2041 18.7938L43.5848 22.0065C44.7701 19.0718 47.6408 16.9998 51.0001 16.9998C53.0394 16.9998 54.8948 17.7692 56.3074 19.0258L60.0788 15.2545C57.6974 13.0352 54.5121 11.6665 51.0001 11.6665C45.8788 11.6665 41.4374 14.5578 39.2041 18.7938Z" fill="#FF3D00" />
			<path d="M50.9999 38.3333C54.4439 38.3333 57.5732 37.0153 59.9392 34.872L55.8125 31.38C54.4739 32.394 52.8099 33 50.9999 33C47.5319 33 44.5872 30.7886 43.4779 27.7026L39.1299 31.0526C41.3365 35.3706 45.8179 38.3333 50.9999 38.3333Z" fill="#4CAF50" />
			<path d="M64.074 22.3888H63V22.3335H51V27.6668H58.5353C58.0073 29.1582 57.048 30.4442 55.8107 31.3808L55.8127 31.3795L59.9393 34.8715C59.6473 35.1368 64.3333 31.6668 64.3333 25.0002C64.3333 24.1062 64.2413 23.2335 64.074 22.3888Z" fill="#1976D2" />
		</svg>
	) : (
		<svg
			width={size}
			height={size}
			viewBox="38 12 24 24"
			fill="none"
			aria-hidden="true"
			focusable="false"
		>
			<path d="M48.6665 22.6665H37.9998V11.9998L48.6665 11.9998V22.6665Z" fill="#FF5722" />
			<path d="M62 22.6665H51.3333V11.9998L62 11.9998V22.6665Z" fill="#4CAF50" />
			<path d="M62 36H51.3333V25.3333H62V36Z" fill="#FFC107" />
			<path d="M48.6665 36H37.9998V25.3333H48.6665V36Z" fill="#03A9F4" />
		</svg>
	);
